import api from './api';

/**
 * Fetch paginated products for admin (requires auth).
 * @param {Object} params - { page, per_page, search, status }
 * @returns {Promise<{ data: Array, meta: { current_page, last_page, per_page, total } }>}
 */
export const fetchProducts = async (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.set('page', params.page);
  if (params.per_page) searchParams.set('per_page', params.per_page);
  if (params.search && params.search.trim()) searchParams.set('search', params.search.trim());
  if (params.status) searchParams.set('status', params.status);

  const query = searchParams.toString();
  const endpoint = query ? `/admin/products?${query}` : '/admin/products';
  const { data } = await api.get(endpoint);
  return data;
};

/**
 * Fetch a single product by id (admin).
 */
export const fetchProduct = async (id) => {
  const { data } = await api.get(`/admin/products/${id}`);
  return data;
};

/**
 * Update product (FormData or JSON). Use FormData when uploading images.
 * For FormData, append _method: 'PUT' and POST to the same URL so Laravel accepts files.
 */
export const updateProduct = async (id, payload) => {
  if (payload instanceof FormData) {
    payload.append('_method', 'PUT');
    const { data } = await api.post(`/admin/products/${id}`, payload);
    return data;
  }
  const { data } = await api.put(`/admin/products/${id}`, payload);
  return data;
};

/**
 * Update product status (active/inactive).
 */
export const updateProductStatus = async (id, status) => {
  const { data } = await api.put(`/admin/products/${id}/status`, { status });
  return data;
};
